import { Input } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { autobind } from 'core-decorators';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import { TableController } from '../../controls/TableController';
import { manager_fetchGroups } from '../../lib/api-web/groups';
import modals from '../../stores/modals';
import { Sorting } from '../../web-types/Sorting';

export interface SelectGroupModalProps {
	placeId: number;
	defaultGroupId?: number;
	onDismiss: () => void;
	onConfirm: (groupId: number) => void;
}

@observer
export default class SelectGroupModal extends PureComponent<SelectGroupModalProps> {
	static async show(placeId: number, defaultGroupId?: number): Promise<number | null> {
		return new Promise<number | null>((resolve, reject) => {
			modals.show((close: () => void) => (
				<SelectGroupModal
					placeId={placeId}
					defaultGroupId={defaultGroupId}
					onDismiss={() => {
						close();
						resolve(null);
					}}
					onConfirm={groupId => {
						close();
						resolve(groupId);
					}}
				/>
			));
		});
	}

	@observable contentVisible = false;
	@observable total: number | null = null;
	@observable params: { query: string } = { query: '' };
	@observable selected: number | null = this.props.defaultGroupId || null;

	@autobind
	handleTablePropsUpdate(contentVisible: boolean, total: number | null, rowsPerPage: number) {
		this.contentVisible = contentVisible;
		this.total = total;
	}

	@autobind
	async handleLoad(params: { query: string }, offset: number, limit: number, sorting: Sorting | null) {
		return manager_fetchGroups(this.props.placeId, offset, limit, {
			query: params.query,
			sorting,
		});
	}

	render() {
		return (
			<Modal
				title="Select group"
				onCancel={() => this.props.onDismiss()}
				visible={true}
				closable={false}
				okButtonProps={{
					disabled: !this.selected,
				}}
				onOk={() => {
					this.props.onConfirm(this.selected!);
				}}
			>
				<Input.Search
					style={{ marginBottom: 15 }}
					type="search"
					onSearch={value => (this.params.query = value)}
					placeholder="Search group..."
				/>
				<TableController
					onRowClick={({ id }) => {
						this.selected = id;
					}}
					noSection
					params={this.params}
					load={this.handleLoad}
					onTablePropsUpdate={this.handleTablePropsUpdate}
					rowClass={({ id }) => (this.selected === id ? 'row-selected' : 'dummy-class')}
					columns={[
						{
							key: 'group_name',
							title: 'Name',
							sortable: true,
						},
						{
							key: 'userRelations.length',
							title: 'Participans',
						},
					]}
				/>
			</Modal>
		);
	}
}
